import React from 'react';

import Image from '../Image';

import { Grid, Stack, Box, Link, Typography, Chip } from '@mui/material';

import { ButtonSmall } from '../button';
import PartnerCategories from '../PartnerCategories';

const PartnerItem = ({
  slug,
  summary: { summary },
  categories,
  name,
  logoLight,
  logoDark,
  relatedPodcasts,
}) => (
  <Grid
    size={{
      xs: 12,
      md: 4
    }}>
    <Stack>
      <Link to={`/partner/${slug}/`}>
        <Image mb={2} srcDark={logoDark} srcLight={logoLight} alt={name} />
      </Link>
      <Box>
        {relatedPodcasts && (
          <Chip
            label="Mit Podcast"
            size="small"
            color="success"
            sx={{ marginRight: 1 }}
          />
        )}
        <PartnerCategories categories={categories} />
        <Typography variant="h5" marginTop={1} gutterBottom>
          {name}
        </Typography>
        <Typography variant="body1" gutterBottom marginBottom={2}>
          {summary}
        </Typography>
        <ButtonSmall href={`https://insurancemedia.de/partner/${slug}/`} target="_blank">Mehr erfahren</ButtonSmall>
      </Box>
    </Stack>
  </Grid>
);

export default PartnerItem;
